<template>
    <div>
        <dx-grid
            url="surveys?type=75-590"
            :columns="columns"
            :title="title"
            ref="grid"
            :onRowClicked="onRowClicked"
            navigationPath="onRowClicked"
            navigationField="onRowClicked"
        ></dx-grid>
        <v-dialog v-model="updateDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="headline px-2 pt-2"
                    >Update Enrollment</v-card-title
                >

                <div class="px-2 mt-0">
                    <v-layout row class="mb-2">
                        <div class="font-weight-medium">
                            {{ clickedRow.nameH }}
                        </div>
                    </v-layout>
                    <v-layout row class="mb-2">
                        <div class="font-weight-medium width-150">Address</div>
                        <div>
                            {{ clickedRow.address1 }}
                        </div>
                    </v-layout>
                    <v-layout row class="mb-2">
                        <div class="font-weight-medium width-150">
                            Primary Phone
                        </div>
                        <div>{{ clickedRow.homePhone }}</div>
                    </v-layout>
                    <v-select
                        v-model="clickedRow.status"
                        label="Status"
                        class="mb-2 mt-3"
                        :items="['PENDING', 'IN PROCESS', 'COMPLETED']"
                        clearable
                    ></v-select>
                    <v-textarea
                        v-model="clickedRow.note"
                        label="Note"
                        class="mb-2"
                        rows="3"
                    ></v-textarea>
                    <v-textarea
                        v-model="clickedRow.note2"
                        label="Note 2"
                        class="mb-3"
                        rows="3"
                    ></v-textarea>
                </div>
                <v-card-actions class="pt-0 mr-2 mt-0 pb-2">
                    <v-spacer></v-spacer>
                    <v-btn dark color="default" @click="updateDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        dark
                        color="success"
                        @click="save()"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div></template
>
<script>
import moment from "moment";

export default {
    data: () => ({
        title: "75 Enrollments",
        clickedRow: {},
        updateDialog: false,
        processing: false,

        columns: [
            {
                label: "Family ID",
                field: "familyID",
                link: "Account View",
                format: "",
                template: "link-cell-template",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Name",
                field: "name",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Name Hebrew",
                field: "nameH",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Date",
                field: "date",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: true,
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Survay Answer",
                field: "survayAnswer",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Status",
                field: "status",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Note",
                field: "note",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Note 2",
                field: "note2",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Student ID",
                field: "studentID",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Student Eng Name",
                field: "studentEngName",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Student Hebrew Name",
                field: "studentHebName",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Student Age",
                field: "studentAge",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Student Registered",
                field: "studentRegistered",
                type: "boolean",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Class Section 1",
                field: "classSection",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Class Section 2",
                field: "classSection2",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Student DOB",
                field: "studentDOB",
                type: "date",
                format: "MM/dd/yyyy",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Updated By",
                field: "updatedBy",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Updated At",
                field: "updatedAt",
                visible: false,
                filterValues: [],
                filterValue: null,
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                selectedFilterOperation: null,
            },
            // {
            //     label: "Message",
            //     template: "link-audio-cell-template",
            //     field: "message",
            //     visible: true,
            //     filterValues: [],
            //     filterValue: null,
            //     selectedFilterOperation: null,
            // },
            {
                label: "Survay Type",
                field: "survayType",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],

        actions: [],
    }),
    created() {},
    mounted() {},
    methods: {
        onRowClicked(row) {
            this.clickedRow = JSON.parse(JSON.stringify(row));

            if (!this.clickedRow.status) {
                this.clickedRow.status = "PENDING";
            }

            this.updateDialog = true;
        },
        async save() {
            try {
                this.processing = true;

                await this.$http.post("api/Surveys/save", {
                    id: this.clickedRow.id,
                    status: this.clickedRow.status,
                    note: this.clickedRow.note,
                    note2: this.clickedRow.note2,
                    updatedBy: this.$store.state.authentication.user,
                });

                this.processing = false;
                this.updateDialog = false;

                this.$notify({
                    text: "Changes Saved",
                    group: "notification",
                    type: "success",
                });

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
    },
};
</script>
